import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FaTimes } from 'react-icons/fa';
export default function ModalCloseButton(props) {
    return (_jsx("div", { style: { position: 'absolute', top: 4, right: 4 }, children: _jsx("button", { type: "button", style: { padding: '10px 6px 10px 6px' }, onClick: props.onClick, css: css({
                color: 'rgba(239, 68, 68)',
                ':hover': { color: 'rgba(185, 28, 28)' },
            }), children: _jsx(FaTimes, {}) }) }));
}
//# sourceMappingURL=ModalCloseButton.js.map